import React from 'react'
import MessageUI from '../../widgets/output/MessageUI'
import SwitchUI from '../../widgets/action/SwitchUI'
import SearchUI from '../../widgets/input/SearchUI'
import LRTableBodyUI from '../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../widgets/layout/LRTableRowUI'
import LRTableActionsUI from '../../widgets/layout/LRTableActionsUI'
import IconButtonUI from '../../widgets/action/IconButtonUI'

const NotificationsUI = ({context, messageList,
    // user notif
    emailAcceptance, submitted, onEmailAcceptanceChange,
    // project notif
    projectList, filteredProjectList, onProjectEmailAcceptanceChange,
    // refresh, filter
    onRefreshClick, searchFilter, onSearchFilterChange
  }) =>
  <div className='c_notif'>
    <LRTableBodyUI context={context} className='menu'>
      <LRTableRowUI
        context={context}
        left={<label><MessageUI messageList={messageList} messageKey='c_all_notifications' /></label>}
        right={
          <SwitchUI
            withSpinner={true}
            checked={emailAcceptance === 'accept'}
            busy={submitted}
            onChange={onEmailAcceptanceChange}
          />
        }
      />
    </LRTableBodyUI>
    {
      emailAcceptance === 'block' &&
      <div className='g_muted g_m_left_50 g_m_top_50'>
        <MessageUI messageList={messageList} messageKey='c_acc_notif_still_sent' />
      </div>
    }

    {
      emailAcceptance === 'accept' && projectList.length > 0 && filteredProjectList &&
      <React.Fragment>
        <h4 className='g_m_left_25'>
        <MessageUI messageList={messageList} messageKey='c_prj_notifications' />
        </h4>
        <LRTableActionsUI location='top'
          left={
            <ActionLeftUI
              context={context}
              messageList={messageList}
              onRefreshClick={onRefreshClick}
            />
          }
          right={
            <ActionTopRightUI
              context={context}
              messageList={messageList}
              searchFilter={searchFilter}
              onSearchFilterChange={onSearchFilterChange}
            />
          }
        />
        <LRTableBodyUI context={context} className='menu'>
          {
            filteredProjectList.map((project, i) =>
              <LRTableRowUI key={i}
                context={context}
                left={<RowLeftUI context={context} messageList={messageList} project={project} />}
                right={
                  <SwitchUI
                    withSpinner={true}
                    rowId={project.projectId}
                    checked={project.emailAcceptance === 'accept'}
                    busy={project.submitted}
                    onChange={onProjectEmailAcceptanceChange}
                  />
                }
              />
            )
          }
        </LRTableBodyUI>
      </React.Fragment>
    }
  </div>

const RowLeftUI = ({context, messageList, project}) =>
  <div>
    <label className='name'>{project.projectName}</label>
    {
      project.projectType === 'template' &&
      <span className='icon icon-cube tag'></span>
    }
    {
      project.visibility === 'all' &&
      <span className='icon icon-globe tag'></span>
    }
  </div>

const ActionLeftUI = ({context, messageList, onRefreshClick}) =>
  <IconButtonUI messageList={messageList} icon='icon-refresh' onClick={onRefreshClick} labelKey='c_refresh' />

const ActionTopRightUI = ({context, messageList, searchFilter, onSearchFilterChange}) =>
  <SearchUI value={searchFilter} onChange={onSearchFilterChange} />

export default NotificationsUI
